import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetAllCancellationReasonsUseCaseInterface } from 'domain/usecases';

interface ICancellationReasonsState {
  cancellationReasons: GetAllCancellationReasonsUseCaseInterface.Result;
}

interface IPayloadCancellationReasons
  extends PayloadAction<GetAllCancellationReasonsUseCaseInterface.Result> {}

const initialState: ICancellationReasonsState = {
  cancellationReasons: [],
};

export const CancellationReasonsSlice = createSlice({
  name: 'cancellation-reasons',
  initialState,
  reducers: {
    loadCancellationReasons: (state, action: IPayloadCancellationReasons) => {
      state.cancellationReasons = action.payload;
    },

    clearCancellationReasons: (state) => {
      state.cancellationReasons = [];
    },
  },
});

export const { loadCancellationReasons, clearCancellationReasons } =
  CancellationReasonsSlice.actions;

export default CancellationReasonsSlice.reducer;
